import CustomSelectAsync from "../../../common/interactive/CustomSelectAsync";

export default function AsyncOption({classes, filtersValues, item, action, path, itemObj}) {

    return <div className={classes.row}>
        <CustomSelectAsync label={item.label} identifier={{type: item.key}} action={action} path={path} preSelectedValue={filtersValues && filtersValues[item.key] && filtersValues[item.key]} isCollections={itemObj?.iscollection}/>
    </div>
}